import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {Modal} from '@mui/material'
import Fade from "@material-ui/core/Fade";
import {useTranslation} from "react-i18next";
import Button from "@mui/material/Button";

const useStyles = makeStyles((theme) => ({
    modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
    },
    root: {
        "& .MuiButton-root": {
            height:46,
            backgroundColor: "#FCB01F",
            "&:hover": {
                //you want this to be the same as the backgroundColor above
                backgroundColor: "#E3A01B"
            },
            "&:focus": {
                //you want this to be the same as the backgroundColor above
                backgroundColor: "#C98E18",
            }
        }
    },
}));

export default function ModalWindowError({open, handleClose}) {
    const classes = useStyles();
    const {t} = useTranslation()

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={open}
            onClose={handleClose}
            closeAfterTransition
        >
            <Fade in={open}>
                <div className="modalWindowSize">
                    <div className="modalWindowTitle">{t('ooops_title')}</div>
                    <div className="modalWindowText">{t('ooops_text')}</div>
                    <div className="buttonPaddingModal">
                        <div className={classes.root} >
                            <Button disableRipple variant="contained" className="button maxWidthModalButton" onClick={handleClose}>
                                <span className="textButton">{t('ok_btn')}</span>
                            </Button>
                        </div>
                    </div>
                </div>
            </Fade>
        </Modal>
    )
}
